import * as ko from 'knockout';

import { I18nText } from '../i18n_text';
import { CountryData } from '../api/countries';
import { GlobalRegionData } from '../api/global_regions';
import { FormSelectSearchConfiguration } from '../components/form_select_search';
import { getCountrySearchConfig } from '../components/configs/search_configs';
import { session } from '../session';

export class GlobalRegion {
  id = ko.observable<string>(null);
  nameJson = ko.observable<I18nText>().extend({
    i18nTextRequired: true,
    serverError: true,
  });
  countries = ko.observableArray<CountryData>([]);
  canEdit = ko.pureComputed(() => session.isAtLeastEditor());
  editUrl: string | null;

  countriesSearchConfig: FormSelectSearchConfiguration<CountryData> = getCountrySearchConfig(
    this.countries,
    { disableCreate: true }
  );

  constructor(data?: GlobalRegionData) {
    if (data) {
      this.id(data.id);
      this.nameJson(data.name_json);
      this.countries(data.countries || []);
    }

    this.editUrl = this.id() ? '/global_regions/' + this.id() : null;
  }

  toData(): GlobalRegionData {
    return {
      id: this.id(),
      name_json: this.nameJson(),
      countries: this.countries(),
    };
  }
}
